// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { actions as StoreActions } from '../duck';
import Store from '../components/Store';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    store: state.store.store,
    isFetchingStore: state.store.isFetchingStore,
    locale: state.locale,
    localValues: state.localValues,
    chosenVariants: state.abTest.chosenVariants,
    isClaimingPoints: state.punchCard.isClaimingPoints,
    claimPointsError: state.punchCard.claimPointsError,
    coupon: state.punchCard.coupon,
    isFetchingWishList1: state.store.isFetchingWishList1,
    isFetchingWishList2: state.store.isFetchingWishList2,
    wishList1: state.store.wishList1,
    wishList2: state.store.wishList2,
    fetchWishList1Error: state.store.fetchWishList1Error,
    fetchWishList2Error: state.store.fetchWishList2Error,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...StoreActions,
    goToRedirect: (route: string) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Store);



// WEBPACK FOOTER //
// ./src/modules/store/containers/StoreContainer.jsx